"use strict";

import { EventListener } from "../systems/secondary/eventListener.js";

export class ObjectCreator {
    static createParenting(object,config) {
        if (config.parent !== undefined) {
            object.parentContainer = config.parent;
            object.parentContainer.addChild(object);
        }
    }

    static createAnchoring(object,hasPivot,is3D,config) {
        object.anchoring = { 
            anchor: { x: 0, y: 0 },
            margin: { x: 0, y: 0 }
        };
        
        if (is3D) {
            object.anchoring.margin.z = 0;
        }
        if (hasPivot) {
            object.anchoring.pivot = { x: 0.5, y: 0.5 };
        }

        if (config.anchoring !== undefined) {
            if (config.anchoring.anchor !== undefined) {
                if (config.anchoring.anchor.x !== undefined) {
                    object.anchoring.anchor.x = config.anchoring.anchor.x;
                    object.anchoring.anchor.y = config.anchoring.anchor.y;
                } else {
                    object.anchoring.anchor.x = config.anchoring.anchor;
                    object.anchoring.anchor.y = config.anchoring.anchor;
                }
            }

            if (hasPivot && config.anchoring.pivot !== undefined) {
                if (config.anchoring.pivot.x !== undefined) {
                    object.anchoring.pivot.x = config.anchoring.pivot.x;
                    object.anchoring.pivot.y = config.anchoring.pivot.y;
                } else {
                    object.anchoring.pivot.x = config.anchoring.pivot;
                    object.anchoring.pivot.y = config.anchoring.pivot;
                }
            }

            if (config.anchoring.margin !== undefined) {
                if (config.anchoring.margin.x !== undefined) {
                    object.anchoring.margin.x = config.anchoring.margin.x;
                    object.anchoring.margin.y = config.anchoring.margin.y;
                    if (is3D) {
                        object.anchoring.margin.z = config.anchoring.margin.z ?? 0;
                    }
                } else {
                    object.anchoring.margin.x = config.anchoring.margin;
                    object.anchoring.margin.y = config.anchoring.margin;
                    if (is3D) {
                        object.anchoring.margin.z = config.anchoring.margin;
                    }
                }
            }

            object.anchoring.anchorBounds = config.anchoring.anchorBounds;
        } else if (hasPivot && config.pivot !== undefined) {
            if (config.pivot.x !== undefined) {
                object.anchoring.pivot.x = config.pivot.x;
                object.anchoring.pivot.y = config.pivot.y;
            } else {
                object.anchoring.pivot.x = config.pivot;
                object.anchoring.pivot.y = config.pivot;
            }
        }
    }

    static setPosition(object,is3D,config) {
        object._tPosition = { x: 0, y: 0 };
        if (is3D) {
            object._tPosition.z = 0;
        }

        if (config.position !== undefined) {
            object.anchoring.margin.x = config.position.x;
            object.anchoring.margin.y = config.position.y;
            if (is3D) {
                object.anchoring.margin.z = config.position.z ?? 0;
            }
        } else {
            object.anchoring.margin.x = config.x ?? object.anchoring.margin.x;
            object.anchoring.margin.y = config.y ?? object.anchoring.margin.y;
            if (is3D) {
                object.anchoring.margin.z = config.z ?? object.anchoring.margin.z;
            }
        }
    }

    static setScale(object,config) {
        if (config.scale !== undefined) {
            if (config.scale.x === undefined) {
                object.scale.set(config.scale, config.scale);
            } else {
                object.scale.set(config.scale.x, config.scale.y);
            }
        }
    }

    static setSize(object,config) {
        if (config.size !== undefined) {
            if (typeof config.size === "number") {
                object.width = config.size;
                object.height = config.size;
                return;
            }
            
            object.width = config.size.width ?? config.size.x ?? 0;
            object.height = config.size.height ?? config.size.y ?? 0;
        } else {
            if (config.width !== undefined) {
                object.width = config.width;
            }
            if (config.height !== undefined) {
                object.height = config.height;
            }
        }
    }

    static setFlipping(object,config) {
        if (config.flip !== undefined) {
            object.flipX = config.flip;
            object.flipY = config.flip;
        } else {
            object.flipX = config.flipX ?? false;
            object.flipY = config.flipY ?? false;
        }
    }

    static setRotationAngle(object,config) {
        object.angle = config.angle ?? 0;
    }
    static setVisibility(object,config) {
        object.visible = config.visible ?? true;
    }
    static setRenderability(object,config) {
        object.renderable = config.renderable ?? true;
    }

    static set3DRotations(object,config) {
        if (config.rotation !== undefined) {
            object.eulerAngles = {...config.rotation};
        } else {
            object.eulerAngles = { x: 0, y: 0, z: 0 };
        }

        object.setRotationX(object.eulerAngles.x);
        object.setRotationY(object.eulerAngles.y);
        object.setRotationZ(object.eulerAngles.z);
    }

    static set3DFunctions(object) {
        object.isFrontFacing = () => {
            const mat = object.proj.world.mat4;
            const dx1 = mat[0] * mat[15] - mat[3] * mat[12];
            const dy1 = mat[1] * mat[15] - mat[3] * mat[13];
            const dx2 = mat[4] * mat[15] - mat[7] * mat[12];
            const dy2 = mat[5] * mat[15] - mat[7] * mat[13];
            return dx1 * dy2 - dx2 * dy1 > 0;
        }
    }

    static setResolutionListeners(object,advanced,config) {
        object._onResolutionWillChangeCallback = config.onResolutionWillChange;
        object._onResolutionChangedCallback = config.onResolutionChanged;
        if (!advanced) return;
        object._onResolutionChangedAfterCallback = config.onResolutionChangedAfter;
    }

    static setOrientationListeners(object,advanced,config) {
        object._onOrientationChangedCallback = config.onOrientationChanged;
        if (!advanced) return;
        object._onOrientationWillChangeCallback = config.onOrientationWillChange;
    }

    static setDisposeCallbacks(object) {
        object._onDispose = new EventListener();
    }
}